import React, { useState } from 'react';
import { ShoppingBasket } from '../../components/ShoppingBasket/ShoppingBasket';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import PageHead from '../../components/Generic/PageHead';
import { IPlainProduct } from '../../backend/types/generic';
import { PLLogo } from '../../components/Generic/PLLogo';
import { Container, Grid, Link, CircularProgress } from '@material-ui/core';
import { CenterBox } from '../../components/Generic/CenterBox';
import { GET_PRODUCT_BY_SLUG } from '../../client-api/graphql/queries';
import { ICheckoutResult } from '../../backend/types/responses';
import { HiddenSubmitForm } from '../../components/ShoppingBasket/HiddenSubmitForm';
import { Header } from '../../components/Generic/Header';

export interface IAction extends Record<string, any> {
  type: string;
}

export interface IBasketItem extends IPlainProduct {
  quantity: number;
}

interface IProps {
  id: string;
}

const Checkout: React.FC<IProps> = (props: IProps) => {
  const router = useRouter();

  // For some reason, useQuery loading always returns false
  const [loading, setLoading] = useState<boolean>(true);

  const [checkoutCompleted, setCheckoutCompleted] = useState<ICheckoutResult>(null);

  const completeCheckout = (response: ICheckoutResult) => {
    setCheckoutCompleted(response);
  };

  const { slug } = router.query;
  const { error, data } = useQuery(GET_PRODUCT_BY_SLUG, {
    variables: { slug },
    skip: !slug,
    onCompleted() {
      setLoading(false);
    },
  });
  return (
    <>
      <PageHead />
      <Header>
        <Container maxWidth="lg">
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            style={{ padding: '1em 0em' }}
          >
            <PLLogo height={48} width={128} />
          </Grid>
        </Container>
      </Header>
      {error ? (
        <CenterBox textAlign="center" height="auto">
          An error has occurred, please try again.
        </CenterBox>
      ) : data?.getProductBySlug === null || data?.getProductBySlug.onSale === false ? (
        <CenterBox textAlign="center" height="auto">
          <p>Product not found.</p>
          <p>
            <Link href={'https://www.procurementleaders.com'}>Procurement Leaders</Link>
          </p>
        </CenterBox>
      ) : checkoutCompleted ? (
        <CenterBox textAlign="center" height="auto">
          <CircularProgress size={24} />
          <HiddenSubmitForm checkout={checkoutCompleted} />
        </CenterBox>
      ) : (
        <ShoppingBasket
          onCheckoutCompleted={(resp) => completeCheckout(resp)}
          product={data && data.getProductBySlug}
          loading={loading}
          id={props.id}
        />
      )}
    </>
  );
};

(Checkout as any).getInitialProps = async ({ req }) => {
  return { id: req.req_id };
};

export default Checkout;
